import React, {useState} from "react";
import { companyComplainsTableHead } from "../../../app/config";
import {ComplainsTableRow, TableHeader} from "../../table";
import { Table, TableBody, TableContainer } from "@mui/material";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import CompanyComplainsTableFilter from "./companyComplainsTableFilter";
import useComplaints from "../../../hooks/useComplaints";
import TablePagination from "./tablePagination";

function CompanyComplainsList({ companyId }) {
    const { t } = useTranslation('CompanyComplainsList');
    
    const [open, setOpen] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);
    const {data: complains, filter, setFilter, nextPage, previousPage, refresh, pagination} = useComplaints({companyId});
    const onRequestSort = (event, property) => {
        const direction = filter.orderBy === property && filter.orderDirection === "asc" ? "desc" : "asc";
        setFilter("orderBy", property);
        setFilter("orderDirection", direction);
    }

    const showOnPage = (value) => {
        setFilter("pageSize", value);
    }
    
    const onSelectAll = () => {
        if(selectedItems.length === complains.length) {
            setSelectedItems([]);
        } else {
            setSelectedItems(complains);
        }
    }

    const onRowCheck = (complaint, isChecked) => {
        let selectedComplaints = [...selectedItems];

        if (!isChecked) {
            const alreadySelected = selectedComplaints.some(item => item.id === complaint.id);
            if (!alreadySelected) {
                selectedComplaints.push(complaint);
            }
        } else {
            const index = selectedComplaints.findIndex(item => item.id === complaint.id);
            if (index !== -1) {
                selectedComplaints.splice(index, 1);
            }
        }

        setSelectedItems(selectedComplaints);
    };

    const handleSetFilter = (fieldName, value) => {
        setFilter(fieldName, value);
    }
    
    const handleRowClick = (id) => setOpen(open ? null : id);

    const handleOnMergeFinished = () => {
        setSelectedItems([]);
        refresh();
    }
    
    if(!filter) {
        return null;
    }

    return (
        <div className="fk-company-complains-list">
            <CompanyComplainsTableFilter 
                hideTitle 
                hideSearch
                companyId={companyId}
                setFilter={handleSetFilter}
                filter={filter}
                listTitle={t('title')}
                selectedItems={selectedItems}
                onMergeFinished={handleOnMergeFinished}
            />
            <TableContainer>
                <Table size="medium" className="fk-table">
                    <TableHeader
                        crud
                        withCheckbox
                        items={companyComplainsTableHead}
                        orderBy={filter.orderBy}
                        order={filter.orderDirection}
                        numSelected={selectedItems.length}
                        rowCount={complains.length}
                        onRequestSort={onRequestSort}
                        onSelectAllClick={onSelectAll}
                        screen="ComplainsScreen"
                    />
                    <TableBody>
                    {complains?.map((complain) => {
                        const isChecked = _.some(selectedItems, (item) => item.id === complain.id);
                        
                        return (
                            <ComplainsTableRow
                                key={complain.id}
                                checked={isChecked}
                                open={open === complain.id}
                                complain={complain}
                                columns={companyComplainsTableHead}
                                onCheck={() => onRowCheck(complain, isChecked)}
                                onRowClick={handleRowClick}
                            />
                        )
                    })}
                    </TableBody>
                </Table>
                {complains.length === 0 &&
                    <p className="fk-no-items">
                        {t('noRecords')}
                    </p>
                }
            </TableContainer>
            <TablePagination
                pagination={pagination}
                handlePreviousPage={previousPage}
                handleNextPage={nextPage}
                showOnPage={showOnPage}
            />
        </div>
    );
}


export default CompanyComplainsList;